import { mapLocaleToMeaningfulFormat } from '@/helpers/utils/i18n';

const SecurityCodeTooltip = () => {
  return (
    <section>
      <p className="pb-3 text-sm font-semibold leading-5">Security Code</p>
      <section className="text-sm  font-normal leading-4">
        <section>
          <p className="pb-3">{mapLocaleToMeaningfulFormat().securityCodeDescLine1}</p>
          <p className="pb-3">{mapLocaleToMeaningfulFormat().securityCodeDescLine2}</p>
          <p>{mapLocaleToMeaningfulFormat().securityCodeDescLine3}</p>
        </section>
      </section>
    </section>
  );
};

export default SecurityCodeTooltip;
